module.exports = __webpack_public_path__ + "img/tag_blank_front.9fefca41.svg";